import { render, staticRenderFns } from "./GlobalKeyEnter.vue?vue&type=template&id=1f52d82c&scoped=true&lang=pug&"
import script from "./GlobalKeyEnter.vue?vue&type=script&lang=ts&"
export * from "./GlobalKeyEnter.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalKeyEnter.vue?vue&type=style&index=0&id=1f52d82c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f52d82c",
  null
  
)

export default component.exports